import React from 'react';

import { CommunityFeedItemWithSymbol } from '@flipster/apis/v1/community/types';
import { getSegmentPositionStatus } from '@flipster/features/src/shared/community-feed/event';
import { FeedCard } from '@flipster/features/src/shared/community-feed/feed-card';
import { FeedItemContext } from '@flipster/features/src/shared/community-feed/post-and-edit/bunja';
import { getSegmentPositionSide } from '@flipster/features/src/shared/position/segment';
import { Trigger } from '@flipster/react/misc/browser/intersection';
import { Styles, css } from '@flipster/styled-system/css';
import { map } from '@flipster/utils/map';
import segment from '@flipster/utils/segment';
import { CommunityEvent } from '@flipster/utils/segment/events/community';

import { SymbolGeneratedContents } from './generated-contents';
import { LivePnlShoutout } from './generated-contents/live-pnl-shoutout';

const generatedFeedCount = 2;
const generatedFeedSymbol = Symbol('generated');
const shoutoutFeedCount = 3;
const shoutoutFeedSymbol = Symbol('shoutout');

interface FeedProps {
  feed: CommunityFeedItemWithSymbol[];
  css?: Styles;
  itemCss: Styles;
  showGenerated: boolean;
  fetchNextPage: () => void;
}
export const FeedList = React.memo(({ feed, css: cssProps, showGenerated, fetchNextPage, itemCss }: FeedProps) => {
  const augmented = showGenerated
    ? ([
        ...feed.slice(0, generatedFeedCount),
        generatedFeedSymbol,
        ...feed.slice(generatedFeedCount, shoutoutFeedCount),
        shoutoutFeedSymbol,
        ...feed.slice(shoutoutFeedCount),
      ] as const)
    : feed;
  return (
    <div className={css(cssProps)}>
      {augmented.map((item, idx) => {
        if (item === generatedFeedSymbol) return <SymbolGeneratedContents key='generated' css={itemCss} />;
        if (item === shoutoutFeedSymbol) return <LivePnlShoutout key='shoutout' css={itemCss} />;
        return (
          <React.Fragment key={item.feedId}>
            {idx === feed.length - 10 && <Trigger onTrigger={fetchNextPage} />}
            <FeedItemContext value={item}>
              <FeedCard
                eventLocation='trade_feed_tab'
                css={itemCss}
                onDropdownClick={() => {
                  segment.track(CommunityEvent.FeedPositionElipsClick, {
                    profile_id: item.profileId,
                    profile_ranking: item.weeklyLeaderboardRank?.toString(),
                    profile_username: item.nickname,
                    symbol: item.symbol,
                    leverage: item.positionCard?.initLeverage,
                    side: map(item.positionCard?.side, (side) => getSegmentPositionSide(side)),
                    position_status: map(item.positionCardType, (type) => getSegmentPositionStatus(type)),
                    feed_id: item.feedId,
                  });
                }}
              />
            </FeedItemContext>
          </React.Fragment>
        );
      })}
    </div>
  );
});
